<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="messagings"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>

</template>

<script>
    /**
     * Allows the selection of a messaging type ID by choosing its name from
     * a selection downloaded from the API on creation
     */
    export default {
        name: 'ies-messaging',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                messagings: [],
                viewValue: this.field.value,
            }
        },
        created:function() {
            this.getMessagings();
        },
        methods: {
            getMessagings:function(){
                axios.get('/api/messaging/selectable-message-templates')
                .then(function(response){
                    console.log(response);
                    var messagings = [];
                    response.data.forEach(function(messaging){
                        // The issue here is that the original code used a string field instead of the ID number of the foreign key
                        // so until that is rectified at source we need to reference the title instead of the ID in the value
                        //messagings.push({ text: messaging.title, value: messaging.messaging_key });
                        messagings.push({ text: messaging.title, value: messaging.title });
                    });
                    this.messagings = messagings;
                }.bind(this));
            },
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
